import { render, staticRenderFns } from "./passwordEdit.vue?vue&type=template&id=47fdbb41&scoped=true&"
import script from "./passwordEdit.vue?vue&type=script&lang=js&"
export * from "./passwordEdit.vue?vue&type=script&lang=js&"
import style0 from "./passwordEdit.vue?vue&type=style&index=0&id=47fdbb41&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fdbb41",
  null
  
)

export default component.exports